"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  send: function send(data) {
    return request.post('feedbacks/send', data);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzZW5kIiwiZGF0YSIsInJlcXVlc3QiLCJwb3N0Il0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vbGlicmFyeS9zcmMvY2xpZW50L21vZHVsZXMvRmVlZGJhY2svRmVlZGJhY2tBY3Rpb25zLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcclxuICAgIHNlbmQ6IChkYXRhKSA9PiByZXF1ZXN0LnBvc3QoJ2ZlZWRiYWNrcy9zZW5kJywgZGF0YSksXHJcbn1cclxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7b0NBQWU7RUFDWEEsSUFBSSxFQUFFLFNBQUFBLEtBQUNDLElBQUk7SUFBQSxPQUFLQyxPQUFPLENBQUNDLElBQUksQ0FBQyxnQkFBZ0IsRUFBRUYsSUFBSSxDQUFDO0VBQUE7QUFDeEQsQ0FBQyJ9